// extracted by mini-css-extract-plugin
export var formInfo = "fk_KR";
export var formInfo__image = "fk_KL";
export var formInfo__link = "fk_KQ";
export var formInfo__list = "fk_KN";
export var formInfo__sectionHr = "fk_KP";
export var formInfo__services = "fk_KK";
export var formInfo__title = "fk_KM";